import { monthFromDateYmd } from './keyRegistry';

export type InvalidationRuleId =
  | 'menu.save'
  | 'subscription.freeze'
  | 'subscription.unfreeze'
  | 'subscription.cancel'
  | 'subscription.cancelPending'
  | 'checkout.complete'
  | 'address.deliverySchedule';

export type InvalidationParams = {
  customer_id: number;
  /** YYYY-MM-DD — menu.save */
  date?: string;
  /** Freeze / unfreeze affected dates */
  dates?: string[];
};

export type InvalidationPlan = {
  subscription?: boolean;
  subscription_pending?: boolean;
  calendar?: boolean | 'all' | string[];
  menu_dates?: string[];
  menu_all?: boolean;
};

export function resolveInvalidationPlan(rule_id: InvalidationRuleId, params: InvalidationParams): InvalidationPlan {
  const { customer_id: _customer_id, date, dates } = params;

  switch (rule_id) {
    case 'menu.save':
      return {
        calendar: date ? [monthFromDateYmd(date)] : true,
      };
    case 'subscription.freeze':
    case 'subscription.unfreeze':
      return {
        subscription: true,
        calendar: 'all',
        menu_dates: dates,
        menu_all: dates == null || dates.length === 0,
      };
    case 'subscription.cancel':
      return {
        subscription: true,
        calendar: 'all',
        menu_all: true,
      };
    case 'subscription.cancelPending':
      return {
        subscription_pending: true,
      };
    case 'checkout.complete':
      return {
        subscription: true,
        subscription_pending: true,
        calendar: 'all',
        menu_all: true,
      };
    case 'address.deliverySchedule':
      return {
        subscription: true,
        calendar: 'all',
      };
    default: {
      const _exhaustive: never = rule_id;
      return _exhaustive;
    }
  }
}
